// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Стартовая страница админки */

.home-page {
  --home-card: #ffffff;
  --home-line: var(--border-color, #e2e8f0);
  --home-muted: var(--text-secondary);
  --home-ink: var(--text-heading, var(--text-primary));
  --home-dot: color-mix(in srgb, var(--text-primary) 14%, transparent);
  --home-brand: #facc15;
  --home-violet: #8b5cf6;
  --home-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -12px rgba(15, 23, 42, 0.12);
  --home-shadow-hover: 0 2px 4px rgba(15, 23, 42, 0.05), 0 18px 40px -16px rgba(15, 23, 42, 0.22);

  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 4px 0 32px;
}

:root[data-theme='dark'] .home-page {
  --home-card: rgba(30, 41, 59, 0.72);
  --home-dot: rgba(148, 163, 184, 0.16);
  --home-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 8px 24px -12px rgba(0, 0, 0, 0.5);
  --home-shadow-hover: 0 2px 4px rgba(0, 0, 0, 0.35), 0 18px 40px -16px rgba(0, 0, 0, 0.65);
}

/* ---------- Hero ---------- */

.home-hero {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  padding: 64px 32px 56px;
  border: 1px solid var(--home-line);
  border-radius: 24px;
  background: var(--home-card);
  box-shadow: var(--home-shadow);
  text-align: center;
}

.home-hero-bg {
  position: absolute;
  inset: 0;
  z-index: -1;
  pointer-events: none;
}

.home-hero-grid {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(var(--home-dot) 1px, transparent 1px);
  background-size: 22px 22px;
  mask-image: radial-gradient(ellipse 70% 65% at 50% 40%, #000 30%, transparent 100%);
}

.home-hero-glow {
  position: absolute;
  width: 420px;
  height: 420px;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.22;
  will-change: transform;
}

.home-hero-glow--a {
  top: -160px;
  left: 12%;
  background: var(--accent-primary);
  animation: home-drift-a 18s ease-in-out infinite alternate;
}

.home-hero-glow--b {
  right: 8%;
  bottom: -220px;
  background: var(--home-brand);
  opacity: 0.2;
  animation: home-drift-b 22s ease-in-out infinite alternate;
}

:root[data-theme='dark'] .home-hero-glow--a { opacity: 0.28; }
:root[data-theme='dark'] .home-hero-glow--b { opacity: 0.12; }

@keyframes home-drift-a {
  to { transform: translate3d(120px, 60px, 0) scale(1.1); }
}

@keyframes home-drift-b {
  to { transform: translate3d(-140px, -40px, 0) scale(1.15); }
}

.home-hero-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 820px;
  margin: 0 auto;
}

.home-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  padding: 5px 14px 5px 5px;
  border: 1px solid var(--home-line);
  border-radius: 999px;
  background: color-mix(in srgb, var(--home-card) 80%, transparent);
  backdrop-filter: blur(6px);
  color: var(--home-ink);
  font-size: 0.8125rem;
  font-weight: 500;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);
}

.home-pill-logo {
  width: 24px;
  height: 24px;
}

.home-pill-sep {
  width: 1px;
  height: 14px;
  background: var(--home-line);
}

.home-pill-muted {
  color: var(--home-muted);
  white-space: nowrap;
}

.home-greeting {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 28px 0 0;
  color: var(--home-muted);
  font-size: 1rem;
  font-weight: 500;
}

.home-wave {
  display: inline-block;
  transform-origin: 70% 70%;
  animation: home-wave 2.4s ease-in-out 0.8s 2;
}

@keyframes home-wave {
  0%, 60%, 100% { transform: rotate(0deg); }
  10%, 30% { transform: rotate(14deg); }
  20% { transform: rotate(-8deg); }
  40% { transform: rotate(-4deg); }
  50% { transform: rotate(10deg); }
}

.home-title {
  margin: 10px 0 0;
  color: var(--home-ink);
  font-size: clamp(2rem, 4.4vw, 3.5rem);
  font-weight: 800;
  line-height: 1.06;
  letter-spacing: -0.035em;
  text-wrap: balance;
}

.home-title-accent {
  background: linear-gradient(
    100deg,
    var(--home-muted) 0%,
    var(--accent-primary) 35%,
    var(--home-violet) 60%,
    var(--home-muted) 100%
  );
  background-size: 250% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: home-shimmer 10s ease-in-out infinite alternate;
}

@keyframes home-shimmer {
  from { background-position: 0% 50%; }
  to { background-position: 100% 50%; }
}

.home-lead {
  max-width: 62ch;
  margin: 18px 0 0;
  color: var(--home-muted);
  font-size: 1.0625rem;
  line-height: 1.6;
  text-wrap: pretty;
}

.home-cta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
  margin-top: 30px;
}

.home-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 12px;
  font: inherit;
  font-size: 0.9375rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;
}

.home-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 30%, transparent);
}

.home-btn--primary {
  border: 1px solid transparent;
  background: var(--home-ink);
  color: var(--bg-primary);
  box-shadow: 0 6px 18px -8px color-mix(in srgb, var(--home-ink) 60%, transparent);
}

.home-btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 26px -10px color-mix(in srgb, var(--home-ink) 70%, transparent);
}

.home-btn--primary .custom-icon {
  transition: transform 0.2s ease;
}

.home-btn--primary:hover .custom-icon {
  transform: translateX(3px);
}

.home-btn--ghost {
  border: 1px solid var(--home-line);
  background: var(--home-card);
  color: var(--home-ink);
}

.home-btn--ghost:hover {
  transform: translateY(-1px);
  border-color: color-mix(in srgb, var(--accent-primary) 40%, var(--home-line));
  box-shadow: var(--home-shadow);
}

.home-role {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 22px;
  color: var(--home-muted);
  font-size: 0.8125rem;
}

.home-role b {
  color: var(--home-ink);
  font-weight: 600;
}

/* ---------- Stats band ---------- */

.home-stats-band {
  position: relative;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  padding: 24px;
  border-radius: 24px;
  background:
    radial-gradient(var(--home-dot) 1px, transparent 1px) 0 0 / 22px 22px,
    linear-gradient(135deg, color-mix(in srgb, var(--text-primary) 5%, transparent), transparent 70%);
}

.home-stat {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 16px 22px;
  border: 1px solid var(--home-line);
  border-radius: 18px;
  background: var(--home-card);
  box-shadow: var(--home-shadow);
  color: inherit;
  font: inherit;
  text-align: center;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.home-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: var(--bg-tertiary);
  color: var(--home-ink);
  box-shadow: inset 0 0 0 1px var(--home-line);
}

.home-stat-value {
  display: flex;
  align-items: center;
  min-height: 2.4rem;
  color: var(--home-ink);
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
}

.home-stat-na {
  color: var(--home-muted);
  font-size: 1rem;
  font-weight: 500;
}

.home-stat-label {
  color: var(--home-ink);
  font-size: 0.9375rem;
  font-weight: 600;
}

.home-stat-hint {
  color: var(--home-muted);
  font-size: 0.8125rem;
}

.home-skeleton {
  display: inline-block;
  width: 72px;
  height: 22px;
  border-radius: 8px;
  background: linear-gradient(
    90deg,
    var(--bg-tertiary) 0%,
    color-mix(in srgb, var(--text-primary) 10%, var(--bg-tertiary)) 50%,
    var(--bg-tertiary) 100%
  );
  background-size: 200% 100%;
  animation: home-skeleton 1.2s ease-in-out infinite;
}

@keyframes home-skeleton {
  from { background-position: 100% 0; }
  to { background-position: -100% 0; }
}

/* ---------- Section cards ---------- */

.home-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 12px;
}

.home-section-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.home-tag {
  display: inline-flex;
  align-self: center;
  padding: 3px 10px;
  border: 1px solid var(--home-line);
  border-radius: 8px;
  background: var(--home-card);
  color: var(--home-ink);
  font-size: 0.75rem;
  font-weight: 600;
}

.home-h2 {
  margin: 12px 0 0;
  color: var(--home-ink);
  font-size: clamp(1.5rem, 2.6vw, 2.1rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
}

.home-sub {
  max-width: 60ch;
  margin: 10px 0 0;
  color: var(--home-muted);
  font-size: 0.975rem;
  line-height: 1.55;
}

.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.home-card {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 22px;
  border: 1px solid var(--home-line);
  border-radius: 18px;
  background: var(--home-card);
  box-shadow: var(--home-shadow);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

/* Пятно света под курсором */
.home-card::before,
.home-stat::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  background: radial-gradient(
    280px circle at var(--mx, 50%) var(--my, 0%),
    color-mix(in srgb, var(--accent-primary) 11%, transparent),
    transparent 65%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
}

.home-stat::before {
  z-index: 0;
}

.home-stat > * {
  position: relative;
  z-index: 1;
}

.home-card:hover,
.home-stat:hover {
  transform: translateY(-3px);
  border-color: color-mix(in srgb, var(--accent-primary) 35%, var(--home-line));
  box-shadow: var(--home-shadow-hover);
}

.home-card:hover::before,
.home-stat:hover::before {
  opacity: 1;
}

.home-card:focus-visible,
.home-stat:focus-visible {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 25%, transparent);
}

.home-card-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-bottom: 6px;
  border-radius: 12px;
  background: linear-gradient(
    135deg,
    color-mix(in srgb, var(--accent-primary) 14%, transparent),
    color-mix(in srgb, var(--home-violet) 10%, transparent)
  );
  color: var(--accent-primary);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent-primary) 18%, transparent);
  transition: transform 0.3s ease;
}

.home-card:hover .home-card-icon {
  transform: scale(1.06) rotate(-3deg);
}

.home-card-title {
  color: var(--home-ink);
  font-size: 1.0625rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.home-card-text {
  flex: 1 1;
  color: var(--home-muted);
  font-size: 0.875rem;
  line-height: 1.5;
}

.home-card-go {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  color: var(--accent-primary);
  font-size: 0.8125rem;
  font-weight: 600;
}

.home-card-go .custom-icon {
  transition: transform 0.2s ease;
}

.home-card:hover .home-card-go .custom-icon {
  transform: translateX(4px);
}

/* ---------- Tips ---------- */

.home-tips {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.5fr);
  gap: 32px;
  align-items: center;
  margin-top: 12px;
  padding: 32px;
  border: 1px solid var(--home-line);
  border-radius: 24px;
  background:
    radial-gradient(circle at 0% 0%, color-mix(in srgb, var(--accent-primary) 8%, transparent), transparent 45%),
    radial-gradient(circle at 100% 100%, color-mix(in srgb, var(--home-brand) 10%, transparent), transparent 45%),
    var(--home-card);
  box-shadow: var(--home-shadow);
}

.home-tips-intro {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.home-tips-intro .home-tag {
  align-self: flex-start;
}

.home-tips-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 22px 28px;
}

.home-tip {
  display: flex;
  gap: 12px;
}

.home-tip-icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--bg-tertiary);
  color: var(--home-ink);
  box-shadow: inset 0 0 0 1px var(--home-line);
}

.home-tip-title {
  color: var(--home-ink);
  font-size: 0.9375rem;
  font-weight: 600;
}

.home-tip-text {
  margin-top: 3px;
  color: var(--home-muted);
  font-size: 0.85rem;
  line-height: 1.5;
}

/* ---------- Responsive ---------- */

@media (max-width: 1024px) {
  .home-stats-band {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .home-tips {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 600px) {
  .home-hero {
    padding: 44px 18px 40px;
    border-radius: 20px;
  }

  .home-pill-sep,
  .home-pill-muted {
    display: none;
  }

  .home-stats-band {
    gap: 10px;
    padding: 12px;
  }

  .home-stat {
    padding: 18px 10px;
  }

  .home-stat-value {
    font-size: 1.6rem;
  }

  .home-tips {
    padding: 22px;
  }

  .home-tips-list {
    grid-template-columns: 1fr;
  }

  .home-btn {
    flex: 1 1 100%;
    justify-content: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .home-hero-glow,
  .home-title-accent,
  .home-wave,
  .home-skeleton {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/dashboard.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,oBAAoB;EACpB,yCAAyC;EACzC,mCAAmC;EACnC,oDAAoD;EACpD,oEAAoE;EACpE,qBAAqB;EACrB,sBAAsB;EACtB,wFAAwF;EACxF,+FAA+F;;EAE/F,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,gFAAgF;EAChF,yFAAyF;AAC3F;;AAEA,+BAA+B;;AAE/B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,uEAAuE;EACvE,0BAA0B;EAE1B,mFAAmF;AACrF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,YAAY;EACZ,0DAA0D;AAC5D;;AAEA,8CAA8C,aAAa,EAAE;AAC7D,8CAA8C,aAAa,EAAE;;AAE7D;EACE,KAAK,iDAAiD,EAAE;AAC1D;;AAEA;EACE,KAAK,oDAAoD,EAAE;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,kCAAkC;EAClC,oBAAoB;EACpB,iEAAiE;EACjE,0BAA0B;EAC1B,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB,uBAAuB,EAAE;EACzC,WAAW,wBAAwB,EAAE;EACrC,MAAM,wBAAwB,EAAE;EAChC,MAAM,wBAAwB,EAAE;EAChC,MAAM,wBAAwB,EAAE;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE;;;;;;GAMC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,0DAA0D;AAC5D;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,6BAA6B,EAAE;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yGAAyG;AAC3G;;AAEA;EACE,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,wBAAwB;EACxB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,kFAAkF;AACpF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,6EAA6E;EAC7E,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB;;qGAEmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB;;;;;GAKC;EACD,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,OAAO,2BAA2B,EAAE;EACpC,KAAK,4BAA4B,EAAE;AACrC;;AAEA,wCAAwC;;AAExC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA,6BAA6B;AAC7B;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;;;;GAIC;EACD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,2BAA2B;EAC3B,6EAA6E;EAC7E,oCAAoC;AACtC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,gFAAgF;AAClF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB;;;;GAIC;EACD,4BAA4B;EAC5B,sFAAsF;EACtF,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;;AAE/B;EACE,aAAa;EACb,wDAAwD;EACxD,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB;;;oBAGkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qCAAqC;;AAErC;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF","sourcesContent":["/* Стартовая страница админки */\n\n.home-page {\n  --home-card: #ffffff;\n  --home-line: var(--border-color, #e2e8f0);\n  --home-muted: var(--text-secondary);\n  --home-ink: var(--text-heading, var(--text-primary));\n  --home-dot: color-mix(in srgb, var(--text-primary) 14%, transparent);\n  --home-brand: #facc15;\n  --home-violet: #8b5cf6;\n  --home-shadow: 0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px -12px rgba(15, 23, 42, 0.12);\n  --home-shadow-hover: 0 2px 4px rgba(15, 23, 42, 0.05), 0 18px 40px -16px rgba(15, 23, 42, 0.22);\n\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  padding: 4px 0 32px;\n}\n\n:root[data-theme='dark'] .home-page {\n  --home-card: rgba(30, 41, 59, 0.72);\n  --home-dot: rgba(148, 163, 184, 0.16);\n  --home-shadow: 0 1px 2px rgba(0, 0, 0, 0.3), 0 8px 24px -12px rgba(0, 0, 0, 0.5);\n  --home-shadow-hover: 0 2px 4px rgba(0, 0, 0, 0.35), 0 18px 40px -16px rgba(0, 0, 0, 0.65);\n}\n\n/* ---------- Hero ---------- */\n\n.home-hero {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  padding: 64px 32px 56px;\n  border: 1px solid var(--home-line);\n  border-radius: 24px;\n  background: var(--home-card);\n  box-shadow: var(--home-shadow);\n  text-align: center;\n}\n\n.home-hero-bg {\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.home-hero-grid {\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(var(--home-dot) 1px, transparent 1px);\n  background-size: 22px 22px;\n  -webkit-mask-image: radial-gradient(ellipse 70% 65% at 50% 40%, #000 30%, transparent 100%);\n  mask-image: radial-gradient(ellipse 70% 65% at 50% 40%, #000 30%, transparent 100%);\n}\n\n.home-hero-glow {\n  position: absolute;\n  width: 420px;\n  height: 420px;\n  border-radius: 50%;\n  filter: blur(80px);\n  opacity: 0.22;\n  will-change: transform;\n}\n\n.home-hero-glow--a {\n  top: -160px;\n  left: 12%;\n  background: var(--accent-primary);\n  animation: home-drift-a 18s ease-in-out infinite alternate;\n}\n\n.home-hero-glow--b {\n  right: 8%;\n  bottom: -220px;\n  background: var(--home-brand);\n  opacity: 0.2;\n  animation: home-drift-b 22s ease-in-out infinite alternate;\n}\n\n:root[data-theme='dark'] .home-hero-glow--a { opacity: 0.28; }\n:root[data-theme='dark'] .home-hero-glow--b { opacity: 0.12; }\n\n@keyframes home-drift-a {\n  to { transform: translate3d(120px, 60px, 0) scale(1.1); }\n}\n\n@keyframes home-drift-b {\n  to { transform: translate3d(-140px, -40px, 0) scale(1.15); }\n}\n\n.home-hero-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: 820px;\n  margin: 0 auto;\n}\n\n.home-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 100%;\n  padding: 5px 14px 5px 5px;\n  border: 1px solid var(--home-line);\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--home-card) 80%, transparent);\n  backdrop-filter: blur(6px);\n  color: var(--home-ink);\n  font-size: 0.8125rem;\n  font-weight: 500;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05);\n}\n\n.home-pill-logo {\n  width: 24px;\n  height: 24px;\n}\n\n.home-pill-sep {\n  width: 1px;\n  height: 14px;\n  background: var(--home-line);\n}\n\n.home-pill-muted {\n  color: var(--home-muted);\n  white-space: nowrap;\n}\n\n.home-greeting {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 28px 0 0;\n  color: var(--home-muted);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.home-wave {\n  display: inline-block;\n  transform-origin: 70% 70%;\n  animation: home-wave 2.4s ease-in-out 0.8s 2;\n}\n\n@keyframes home-wave {\n  0%, 60%, 100% { transform: rotate(0deg); }\n  10%, 30% { transform: rotate(14deg); }\n  20% { transform: rotate(-8deg); }\n  40% { transform: rotate(-4deg); }\n  50% { transform: rotate(10deg); }\n}\n\n.home-title {\n  margin: 10px 0 0;\n  color: var(--home-ink);\n  font-size: clamp(2rem, 4.4vw, 3.5rem);\n  font-weight: 800;\n  line-height: 1.06;\n  letter-spacing: -0.035em;\n  text-wrap: balance;\n}\n\n.home-title-accent {\n  background: linear-gradient(\n    100deg,\n    var(--home-muted) 0%,\n    var(--accent-primary) 35%,\n    var(--home-violet) 60%,\n    var(--home-muted) 100%\n  );\n  background-size: 250% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation: home-shimmer 10s ease-in-out infinite alternate;\n}\n\n@keyframes home-shimmer {\n  from { background-position: 0% 50%; }\n  to { background-position: 100% 50%; }\n}\n\n.home-lead {\n  max-width: 62ch;\n  margin: 18px 0 0;\n  color: var(--home-muted);\n  font-size: 1.0625rem;\n  line-height: 1.6;\n  text-wrap: pretty;\n}\n\n.home-cta {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 30px;\n}\n\n.home-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 44px;\n  padding: 0 20px;\n  border-radius: 12px;\n  font: inherit;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.home-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 30%, transparent);\n}\n\n.home-btn--primary {\n  border: 1px solid transparent;\n  background: var(--home-ink);\n  color: var(--bg-primary);\n  box-shadow: 0 6px 18px -8px color-mix(in srgb, var(--home-ink) 60%, transparent);\n}\n\n.home-btn--primary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 12px 26px -10px color-mix(in srgb, var(--home-ink) 70%, transparent);\n}\n\n.home-btn--primary .custom-icon {\n  transition: transform 0.2s ease;\n}\n\n.home-btn--primary:hover .custom-icon {\n  transform: translateX(3px);\n}\n\n.home-btn--ghost {\n  border: 1px solid var(--home-line);\n  background: var(--home-card);\n  color: var(--home-ink);\n}\n\n.home-btn--ghost:hover {\n  transform: translateY(-1px);\n  border-color: color-mix(in srgb, var(--accent-primary) 40%, var(--home-line));\n  box-shadow: var(--home-shadow);\n}\n\n.home-role {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 22px;\n  color: var(--home-muted);\n  font-size: 0.8125rem;\n}\n\n.home-role b {\n  color: var(--home-ink);\n  font-weight: 600;\n}\n\n/* ---------- Stats band ---------- */\n\n.home-stats-band {\n  position: relative;\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  padding: 24px;\n  border-radius: 24px;\n  background:\n    radial-gradient(var(--home-dot) 1px, transparent 1px) 0 0 / 22px 22px,\n    linear-gradient(135deg, color-mix(in srgb, var(--text-primary) 5%, transparent), transparent 70%);\n}\n\n.home-stat {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 24px 16px 22px;\n  border: 1px solid var(--home-line);\n  border-radius: 18px;\n  background: var(--home-card);\n  box-shadow: var(--home-shadow);\n  color: inherit;\n  font: inherit;\n  text-align: center;\n  cursor: pointer;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n.home-stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px;\n  margin-bottom: 10px;\n  border-radius: 12px;\n  background: var(--bg-tertiary);\n  color: var(--home-ink);\n  box-shadow: inset 0 0 0 1px var(--home-line);\n}\n\n.home-stat-value {\n  display: flex;\n  align-items: center;\n  min-height: 2.4rem;\n  color: var(--home-ink);\n  font-size: 2rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  font-variant-numeric: tabular-nums;\n}\n\n.home-stat-na {\n  color: var(--home-muted);\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.home-stat-label {\n  color: var(--home-ink);\n  font-size: 0.9375rem;\n  font-weight: 600;\n}\n\n.home-stat-hint {\n  color: var(--home-muted);\n  font-size: 0.8125rem;\n}\n\n.home-skeleton {\n  display: inline-block;\n  width: 72px;\n  height: 22px;\n  border-radius: 8px;\n  background: linear-gradient(\n    90deg,\n    var(--bg-tertiary) 0%,\n    color-mix(in srgb, var(--text-primary) 10%, var(--bg-tertiary)) 50%,\n    var(--bg-tertiary) 100%\n  );\n  background-size: 200% 100%;\n  animation: home-skeleton 1.2s ease-in-out infinite;\n}\n\n@keyframes home-skeleton {\n  from { background-position: 100% 0; }\n  to { background-position: -100% 0; }\n}\n\n/* ---------- Section cards ---------- */\n\n.home-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  margin-top: 12px;\n}\n\n.home-section-head {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.home-tag {\n  display: inline-flex;\n  align-self: center;\n  padding: 3px 10px;\n  border: 1px solid var(--home-line);\n  border-radius: 8px;\n  background: var(--home-card);\n  color: var(--home-ink);\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.home-h2 {\n  margin: 12px 0 0;\n  color: var(--home-ink);\n  font-size: clamp(1.5rem, 2.6vw, 2.1rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n}\n\n.home-sub {\n  max-width: 60ch;\n  margin: 10px 0 0;\n  color: var(--home-muted);\n  font-size: 0.975rem;\n  line-height: 1.55;\n}\n\n.home-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 16px;\n}\n\n.home-card {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 22px;\n  border: 1px solid var(--home-line);\n  border-radius: 18px;\n  background: var(--home-card);\n  box-shadow: var(--home-shadow);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;\n}\n\n/* Пятно света под курсором */\n.home-card::before,\n.home-stat::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: radial-gradient(\n    280px circle at var(--mx, 50%) var(--my, 0%),\n    color-mix(in srgb, var(--accent-primary) 11%, transparent),\n    transparent 65%\n  );\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.home-stat::before {\n  z-index: 0;\n}\n\n.home-stat > * {\n  position: relative;\n  z-index: 1;\n}\n\n.home-card:hover,\n.home-stat:hover {\n  transform: translateY(-3px);\n  border-color: color-mix(in srgb, var(--accent-primary) 35%, var(--home-line));\n  box-shadow: var(--home-shadow-hover);\n}\n\n.home-card:hover::before,\n.home-stat:hover::before {\n  opacity: 1;\n}\n\n.home-card:focus-visible,\n.home-stat:focus-visible {\n  outline: none;\n  border-color: var(--accent-primary);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--accent-primary) 25%, transparent);\n}\n\n.home-card-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  margin-bottom: 6px;\n  border-radius: 12px;\n  background: linear-gradient(\n    135deg,\n    color-mix(in srgb, var(--accent-primary) 14%, transparent),\n    color-mix(in srgb, var(--home-violet) 10%, transparent)\n  );\n  color: var(--accent-primary);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--accent-primary) 18%, transparent);\n  transition: transform 0.3s ease;\n}\n\n.home-card:hover .home-card-icon {\n  transform: scale(1.06) rotate(-3deg);\n}\n\n.home-card-title {\n  color: var(--home-ink);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.home-card-text {\n  flex: 1;\n  color: var(--home-muted);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.home-card-go {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 8px;\n  color: var(--accent-primary);\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.home-card-go .custom-icon {\n  transition: transform 0.2s ease;\n}\n\n.home-card:hover .home-card-go .custom-icon {\n  transform: translateX(4px);\n}\n\n/* ---------- Tips ---------- */\n\n.home-tips {\n  display: grid;\n  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.5fr);\n  gap: 32px;\n  align-items: center;\n  margin-top: 12px;\n  padding: 32px;\n  border: 1px solid var(--home-line);\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at 0% 0%, color-mix(in srgb, var(--accent-primary) 8%, transparent), transparent 45%),\n    radial-gradient(circle at 100% 100%, color-mix(in srgb, var(--home-brand) 10%, transparent), transparent 45%),\n    var(--home-card);\n  box-shadow: var(--home-shadow);\n}\n\n.home-tips-intro {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.home-tips-intro .home-tag {\n  align-self: flex-start;\n}\n\n.home-tips-list {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 22px 28px;\n}\n\n.home-tip {\n  display: flex;\n  gap: 12px;\n}\n\n.home-tip-icon {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--bg-tertiary);\n  color: var(--home-ink);\n  box-shadow: inset 0 0 0 1px var(--home-line);\n}\n\n.home-tip-title {\n  color: var(--home-ink);\n  font-size: 0.9375rem;\n  font-weight: 600;\n}\n\n.home-tip-text {\n  margin-top: 3px;\n  color: var(--home-muted);\n  font-size: 0.85rem;\n  line-height: 1.5;\n}\n\n/* ---------- Responsive ---------- */\n\n@media (max-width: 1024px) {\n  .home-stats-band {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .home-tips {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 600px) {\n  .home-hero {\n    padding: 44px 18px 40px;\n    border-radius: 20px;\n  }\n\n  .home-pill-sep,\n  .home-pill-muted {\n    display: none;\n  }\n\n  .home-stats-band {\n    gap: 10px;\n    padding: 12px;\n  }\n\n  .home-stat {\n    padding: 18px 10px;\n  }\n\n  .home-stat-value {\n    font-size: 1.6rem;\n  }\n\n  .home-tips {\n    padding: 22px;\n  }\n\n  .home-tips-list {\n    grid-template-columns: 1fr;\n  }\n\n  .home-btn {\n    flex: 1 1 100%;\n    justify-content: center;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home-hero-glow,\n  .home-title-accent,\n  .home-wave,\n  .home-skeleton {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
